import { CoinMark } from "@/components/brand/Logo";

export const Card3D = () => (
  <div className="card3d-scene" data-testid="card-3d" aria-hidden>
    <div className="card3d">
      <div className="card3d-face card3d-front">
        <div className="flex items-start justify-between"><CoinMark size={34} /><span className="text-xs font-bold tracking-widest text-white/80">VIRTUELLE</span></div>
        <div className="card3d-chip" />
        <div className="font-mono text-lg tracking-[0.18em] text-white">•••• •••• •••• 2026</div>
        <div className="flex items-end justify-between text-white"><div><div className="text-[9px] uppercase text-white/60">Titulaire</div><div className="text-sm font-bold">MON FOYER</div></div><div className="text-right text-xs font-extrabold italic">CASHMY</div></div>
      </div>
      <div className="card3d-face card3d-back">
        <div className="card3d-strip" />
        <div className="mx-5 flex h-9 items-center justify-end rounded bg-white/90 px-3 font-mono text-sm text-slate-700">•••</div>
        <p className="px-5 text-[10px] text-white/70">My cash. My home. My life.</p>
      </div>
    </div>
    <div className="card3d-shadow" />
  </div>
);
